module.exports = __webpack_public_path__ + "static/media/logo-footer-desktop.4d80853e.png";